import type { DeepReadonly } from 'vue';

import type { Pax, RoomPax } from '@libs/trip-planner-interfaces';
import type { Serializer } from '@libs/utils';

export const PaxSerializer: Serializer<DeepReadonly<Pax>> = {
  serialize: (pax: DeepReadonly<Pax>): string => {
    const serializedRoomPaxes = pax.map((roomPax) => {
      const serializedAdults = Array.from(
        { length: roomPax.numberOfAdults },
        () => 'p'
      ).join('');

      const serializedChildren =
        roomPax.childAges?.map((childAge) => `p${childAge}`).join('') ?? '';

      return `r${serializedAdults}${serializedChildren}`;
    });

    return serializedRoomPaxes.join('');
  },
  deserialize: (value: string): DeepReadonly<Pax> => {
    const serializedRooms = value.substring(1).split('r');

    return serializedRooms.map<RoomPax>((serializedRoomPax) => {
      const guestsWithNoAge = serializedRoomPax.match(/p(?![0-9])/gi);
      const guestsWithAge = serializedRoomPax.match(/[0-9]+/gi);

      const numberOfAdults = guestsWithNoAge?.length ?? 0;

      const childAges =
        guestsWithAge?.map((childAge) => parseInt(childAge, 10)) ?? [];

      return {
        numberOfAdults,
        childAges,
      };
    });
  },
};
